import { useTranslation } from 'react-i18next';

import { useInstallPrompt } from '../hooks/use-install-prompt';

// Small inline SVG so we don't grow icons.tsx for a single use site.
function DownloadGlyph({ size = 16 }: { readonly size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable={false}
    >
      <path d="M12 3v12" />
      <path d="M7 10l5 5 5-5" />
      <path d="M5 21h14" />
    </svg>
  );
}

export function InstallButton() {
  const { t } = useTranslation();
  const { canInstall, promptInstall } = useInstallPrompt();

  if (!canInstall) return null;

  const label = t('nav.install');
  const aria = t('nav.a11y.install');

  return (
    <button
      type="button"
      className="nw-btn nw-btn--ghost nw-install-btn"
      onClick={() => void promptInstall()}
      aria-label={aria}
    >
      <DownloadGlyph size={16} />
      <span>{label}</span>
    </button>
  );
}
